import { BG_INPUT_RACE } from 'assets/images'
import styled from 'styled-components'

const SelectCustomGuildRaceStyled = styled.div`
  background: url(${BG_INPUT_RACE});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 40px;

  .select-box-customs {
    position: relative;
    width: 100%;
    color: #6d6d6d;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    height: 40px;
    font-weight: 600;
    font-size: 16px;
    background-color: transparent;
    
    .filter-icon {
      margin-right: 8px;
    }

    .mr-2 {
      margin-right: 8px;
      object-fit: contain;
    }

    span.select-name {
      position: absolute;
      top: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 11px;
      margin-top: 4px;
      .name-icon {
        display: flex;
        align-items: center;
        gap: 12px;
        div {
          color: #fff;
        }
      }
    }
    img.select-drop-icon {
      position: absolute;
      width: 25px;
      height: 25px;
      transform: translateX(220%);
      top: 9px;
      right: 65px;
    }
    img.up-down-icon {
      transform: scaleY(-1) translateX(220%);
    }
    .orange-line {
      left: 0;
      bottom: -1px;
      width: 70px;
      height: 3px;
    }

    &.select-custom {
      ul.select-content-dropdown {
        li {
          text-align: left;
        }
      }
    }
  }

  ul.select-content-dropdown {
    z-index: 111;
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    width: 100%;
    background-color: transparent;
    margin: 0;
    margin-top: 2px;
    padding: 0;
    list-style: none;
    background: #232840;
    max-height: 170px;
    border: 1px solid #eec32c;
    border-top: 1px solid transparent;
    /* background: linear-gradient(180deg, rgba(25, 29, 43, 0.8) 0%, #090911 100%); */

    li {
      color: #ffffff;
      padding: 6px 12px;
      font-weight: 400;
      font-size: 18px;
      line-height: 18px;
      /* border-left: 1px solid #eec32c;
      border-right: 1px solid #eec32c; */
      cursor: pointer;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    li.active {
      background: linear-gradient(
        90deg,
        rgba(227, 109, 2, 0) -2.08%,
        rgba(255, 122, 0, 0.45) 47.38%,
        rgba(227, 109, 2, 0) 101.56%
      );
    }
    li:hover {
      /* background: linear-gradient(
        90deg,
        rgba(227, 109, 2, 0) -2.08%,
        rgba(255, 122, 0, 0.45) 47.38%,
        rgba(227, 109, 2, 0) 101.56%
      ); */
      /* filter: grayscale(1); */
      background: rgb(27,29,38);
      background: linear-gradient(90deg, rgba(27,29,38,1) 0%, rgba(74,75,81,1) 50%, rgba(27,29,38,1) 100%);
    }

    /* .img_contain {
      display: inline-block;
      width: 24px;
      height: 24px;
      margin-right: 5px;
      margin-top: -5px;

      img {
        width: 100%;
        height: 100%;
      }
    } */
  }

  .select-content-dropdown {
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
      background: rgba(52, 58, 64, 0.9);
    }
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background: rgba(28, 34, 39, 0.7);
    }
    ::-webkit-scrollbar-thumb:hover{
      background: rgba(28, 34, 39, 0.7);
    }
    ::-webkit-scrollbar-thumb:active{
      background: rgba(28, 34, 39, 0.9);
    }
  }

  .bottom_line {
    position: absolute;
    display: block;
    width: 100%;
    height: 1px;
    /* border-bottom: 1px solid #eec32c; */
  }
`

export default SelectCustomGuildRaceStyled
